import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/camera.svg'
import _imports_1 from '@/assets/img/chat/chatRequest_on.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-eb3d0936")

_pushScopeId("data-v-eb3d0936")
const _hoisted_1 = {
  class: "writerContainer",
  ref: "chatWriter"
}
const _hoisted_2 = {
  key: 0,
  class: "quotedMessage"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "squareButton ms-2"
}, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = {
  key: 2,
  type: "button",
  class: "squareButton ms-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_uose_writer = _resolveComponent("uose-writer")!
  const _component_file_selector = _resolveComponent("file-selector")!
  const _component_photo_uploader = _resolveComponent("photo-uploader")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "chatMessageContainer",
      ref: "chatMessageContainer",
      style: _ctx.messageContainerStyle,
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollListener && _ctx.scrollListener(...args)))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (item, i) => {
        return (_openBlock(), _createBlock(_component_chat_message, {
          key: item.identifier,
          onLongtouch: _ctx.onLongtouch,
          "show-sender-image": _ctx.showSenderImage(i),
          "show-sender-name": _ctx.showSenderName(i),
          "names-dictionary": _ctx.namesDictionary,
          ref: item.identifier,
          message: item,
          onDeleteMessage: _ctx.deleteMessage,
          canDeleteOther: _ctx.canDeleteOther
        }, null, 8, ["onLongtouch", "show-sender-image", "show-sender-name", "names-dictionary", "message", "onDeleteMessage", "canDeleteOther"]))
      }), 128))
    ], 36),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.showNuoviMessaggi)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "newChatMessages",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToBottom && _ctx.goToBottom(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: 'app_hainuovimessaggi',
                text: 'Hai nuovi messaggi'
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      (_ctx.quotedMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("button", {
              class: "cancel",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelQuote && _ctx.cancelQuote(...args)))
            }, "X"),
            _createVNode(_component_localized_text, {
              localizedKey: "app_rispondiA",
              text: "Rispondi a:",
              class: "fs_12 grey"
            }),
            _createVNode("span", {
              class: "fs_12 spaceCadet text",
              innerHTML: _ctx.quotedMessage.text
            }, null, 8, ["innerHTML"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_uose_writer, {
        class: "genericInput squareInput p-0",
        modelValue: _ctx.messageText,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.messageText = $event)),
        ref: "chatInput",
        placeholderText: 'Scrivi qualcosa',
        placeholderKey: 'app_scriviqualcosa',
        onInput: _ctx.calcWriterHeight,
        "max-height": 200,
        reset: _ctx.reset
      }, null, 8, ["modelValue", "onInput", "reset"]),
      (!_ctx.isDisabled)
        ? (_openBlock(), _createBlock(_component_file_selector, {
            key: 1,
            modelValue: _ctx.file,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.file = $event)),
            accept: 'video/mp4, video/x-m4v, video/*, image/*'
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createBlock("button", _hoisted_4, [
            _hoisted_5
          ])),
      _createVNode("div", {
        class: "squareButton ms-2",
        disabled: !_ctx.messageText.trim() || _ctx.isDisabled,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendMessage()))
      }, [
        _hoisted_6
      ], 8, ["disabled"])
    ], 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.showUploadActionBar)
          ? (_openBlock(), _createBlock(_component_photo_uploader, {
              key: 0,
              onHide: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showUploadActionBar = false)),
              onChangedFile: _ctx.changedFile
            }, null, 8, ["onChangedFile"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})